var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { instanceToPlain, plainToClass } from 'class-transformer';
import queries from 'constants/queries';
import ServiceOrder from 'models/entities/ServiceOrder';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var EMPTY_FILTERS = {};
var hasFilterValue = function (value) {
    if (value == null)
        return false;
    if (typeof value === 'string')
        return value.trim() !== '';
    return true;
};
var toServiceOrderList = function (data) {
    var raw = data;
    if (typeof raw === 'string') {
        try {
            raw = JSON.parse(raw);
        }
        catch (_a) {
            raw = [];
        }
    }
    var list = Array.isArray(raw) ? raw : [];
    return plainToClass(ServiceOrder, list);
};
var itemAttributes = function (item) {
    var payload = {
        order_entity_id: item.getOrderEntityId()
    };
    var packagePriceId = item.getPackagePriceId();
    if (packagePriceId) {
        payload.package_price_id = packagePriceId;
    }
    if (item.getStatus()) {
        payload.status = item.getStatus();
    }
    if (item.getNotes()) {
        payload.notes = item.getNotes();
    }
    return payload;
};
var ServiceOrderService = /** @class */ (function (_super) {
    __extends(ServiceOrderService, _super);
    function ServiceOrderService() {
        var _this = _super.call(this) || this;
        _this.root = 'service_orders';
        _this.successMessage = '';
        return _this;
    }
    ServiceOrderService.prototype.useServiceOrders = function (filters, enabled) {
        var _this = this;
        if (filters === void 0) { filters = EMPTY_FILTERS; }
        if (enabled === void 0) { enabled = true; }
        var params = {};
        if (hasFilterValue(filters.patient_id)) {
            params.patient_id = filters.patient_id;
        }
        if (hasFilterValue(filters.clinic_id)) {
            params.clinic_id = filters.clinic_id;
        }
        if (hasFilterValue(filters.status)) {
            params.status = filters.status;
        }
        if (hasFilterValue(filters.patient_journey_id)) {
            params.patient_journey_id = filters.patient_journey_id;
        }
        if (hasFilterValue(filters.patient_name)) {
            params.patient_name = filters.patient_name.trim();
        }
        if (hasFilterValue(filters.clinic_name)) {
            params.clinic_name = filters.clinic_name.trim();
        }
        if (hasFilterValue(filters.patient_phone_number)) {
            params.patient_phone_number = filters.patient_phone_number.trim();
        }
        return useQuery([queries.serviceOrders, params], function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.get(this.root, Object.keys(params).length ? params : undefined)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, toServiceOrderList(response.data)];
                }
            });
        }); }, {
            enabled: enabled,
            retry: false,
            structuralSharing: false
        });
    };
    ServiceOrderService.prototype.useServiceOrder = function (id, enabled) {
        var _this = this;
        if (enabled === void 0) { enabled = true; }
        return useQuery([queries.serviceOrder, id], function () {
            return _this.get("".concat(_this.root, "/").concat(id));
        }, {
            enabled: enabled && !!id,
            retry: false,
            select: function (_a) {
                var data = _a.data;
                return plainToClass(ServiceOrder, data);
            }
        });
    };
    ServiceOrderService.prototype.useCreateServiceOrder = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrder = _a.serviceOrder, items = _a.items, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var plain = instanceToPlain(serviceOrder);
            delete plain.service_order_items;
            delete plain.transactions;
            delete plain.clinic;
            delete plain.id;
            var payload = __assign(__assign({}, plain), { items: (items || serviceOrder.getItems()).map(function (item) { return itemAttributes(item); }) });
            return _this.post(_this.root, {
                data: { service_order: payload }
            });
        }, {
            retry: false,
            onSuccess: function () {
                queryClient.invalidateQueries(queries.serviceOrders);
                queryClient.invalidateQueries(queries.patientJourneys);
                queryClient.invalidateQueries(queries.patientJourney);
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    ServiceOrderService.prototype.useUpdateServiceOrder = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrder = _a.serviceOrder, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(serviceOrder.getId()), {
                data: { service_order: instanceToPlain(serviceOrder) }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrder.getId());
            }
        });
    };
    ServiceOrderService.prototype.useVoidServiceOrder = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrderId = _a.serviceOrderId, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(serviceOrderId, "/void"), { data: {} });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrderId);
            }
        });
    };
    ServiceOrderService.prototype.useAddItem = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrderId = _a.serviceOrderId, item = _a.item, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post("".concat(_this.root, "/").concat(serviceOrderId, "/add_item"), {
                data: itemAttributes(item)
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrderId);
            }
        });
    };
    ServiceOrderService.prototype.useEditItem = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrderId = _a.serviceOrderId, item = _a.item, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.put("".concat(_this.root, "/").concat(serviceOrderId, "/edit_item"), {
                data: {
                    service_order_item_id: item.getId(),
                    package_price_id: item.getPackagePriceId(),
                    notes: item.getNotes(),
                    status: item.getStatus()
                }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrderId);
            }
        });
    };
    ServiceOrderService.prototype.useRemoveItem = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrderId = _a.serviceOrderId, serviceOrderItemId = _a.serviceOrderItemId, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.delete("".concat(_this.root, "/").concat(serviceOrderId, "/remove_item"), {
                data: { service_order_item_id: serviceOrderItemId }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrderId);
            }
        });
    };
    ServiceOrderService.prototype.useFulfillItem = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var serviceOrderId = _a.serviceOrderId, serviceOrderItemId = _a.serviceOrderItemId, result = _a.result, medicalMachineId = _a.medicalMachineId, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            return _this.post("".concat(_this.root, "/").concat(serviceOrderId, "/fulfill_item"), {
                data: {
                    service_order_item_id: serviceOrderItemId,
                    result: result,
                    medical_machine_id: medicalMachineId
                }
            });
        }, {
            retry: false,
            onSuccess: function (_response, variables) {
                _this.invalidateServiceOrder(queryClient, variables.serviceOrderId);
                queryClient.invalidateQueries(queries.patientJourneys);
                queryClient.invalidateQueries(queries.patientJourney);
                queryClient.invalidateQueries(queries.patientJourneyQueue);
            }
        });
    };
    ServiceOrderService.prototype.invalidateServiceOrder = function (queryClient, id) {
        queryClient.invalidateQueries(queries.serviceOrders);
        queryClient.invalidateQueries([queries.serviceOrder, id]);
        this.dipatachCreationSuccess({ successMessage: this.successMessage });
    };
    ServiceOrderService.getInstance = function () {
        if (!ServiceOrderService.instance) {
            ServiceOrderService.instance = new ServiceOrderService();
        }
        return ServiceOrderService.instance;
    };
    return ServiceOrderService;
}(ApiService));
export default ServiceOrderService;
